import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const storedUser = localStorage.getItem('Auth');
        const storedToken = Cookies.get('auth_token');

        if (storedUser) {
            try {
                setUser(JSON.parse(storedUser));
            } catch (error) {
                setUser(null);
            }
        }

        if (storedToken) {
            setToken(storedToken);
        }

        if (storedUser && storedToken) {
            setIsAuthenticated(true);
        }

        setIsLoading(false);
    }, []);

    const setAuth = (userData, authToken) => {
        localStorage.removeItem('selectedMenuKey');
        localStorage.setItem('Auth', JSON.stringify(userData));
        Cookies.set('auth_token', authToken, { expires: 0.5 });
        setUser(userData);
        setToken(authToken);
        setIsAuthenticated(true);
    };

    const logout = () => {
        localStorage.clear();
        Cookies.remove('auth_token');
        setUser(null);
        setToken(null);
        setIsAuthenticated(false);
    };

    const value = {
        user,
        token,
        setAuth,
        logout,
        isAuthenticated,
        setIsAuthenticated,
        isLoading
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

